import React from 'react'

import Condo from './Condo'

const CondoResults = ({ totalListLength, condoList, handleNewSearch }) => {
  console.log(condoList)
  return <div className='condo-results usa-grid'>
    <h1>Condo Report Results</h1>
    <span className='records-found'>
      <h4>Records found: {totalListLength}</h4>
      <button onClick={handleNewSearch}>New Search</button>
    </span>
    <div className='condo-display'>
      {condoList.map(condo => <Condo key={condo.id} {...condo} />)}
    </div>
  </div>
}
export default CondoResults
